import { render, staticRenderFns } from "./FormReset.vue?vue&type=template&id=6ee1bfa7&scoped=true&"
import script from "./FormReset.vue?vue&type=script&lang=js&"
export * from "./FormReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee1bfa7",
  null
  
)

export default component.exports